export function reportPreviewPath(projectID: string, artifactID: string) {
  return `/reports/${encodeURIComponent(projectID)}/${encodeURIComponent(artifactID)}/preview`
}

export function htmlReportFormat(format: string) {
  return /^(?:html?|text\/html)$/i.test(format.trim().replace(/^\./, ""))
}

export function reportDisplayTitle(title: string) {
  return title.replace(/\.html?$/i, "")
}
